import { AxiosError } from "axios";

export const axiosErrorLoadDataHandler = (
  error: AxiosError,
  showToast: any
) => {
  showToast(error?.response?.data.message, "error");
};
